"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = require("../../utils/userflow");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Modal = /*#__PURE__*/function (_React$PureComponent) {
  function Modal(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _this.el = document.createElement('div');
    return _this;
  }
  (0, _inherits2["default"])(Modal, _React$PureComponent);
  return (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var root = this.props.root;
      var _window = window,
        documentElement = _window.document.documentElement,
        pageYOffset = _window.pageYOffset;
      documentElement.style.position = 'fixed';
      this.scrollTop = pageYOffset;
      documentElement.style.top = "-".concat(this.scrollTop, "px");
      root.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var root = this.props.root;
      var documentElement = window.document.documentElement;
      documentElement.style.position = '';
      documentElement.style.top = '';
      window.scroll(0, this.scrollTop);
      root.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        shadow = _this$props.shadow,
        className = _this$props.className;
      var modal = /*#__PURE__*/_react["default"].createElement(StyledOverlay, {
        className: className
      }, shadow && /*#__PURE__*/_react["default"].createElement(StyledShadow, null), children);
      return /*#__PURE__*/_reactDom["default"].createPortal(modal, this.el);
    }
  }]);
}(_react["default"].PureComponent);
Modal.defaultProps = {
  shadow: true,
  root: _userflow.isSSR ? null : document.body,
  className: ''
};
Modal.propTypes = {
  children: _propTypes["default"].node.isRequired,
  shadow: _propTypes["default"].bool,
  root: _propTypes["default"].node,
  className: _propTypes["default"].string
};
var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "Modal__StyledOverlay",
  componentId: "sc-isf1yd-0"
})(["top:0;left:0;right:0;bottom:0;z-index:1300;position:fixed;"]);
var StyledShadow = _styledComponents["default"].div.withConfig({
  displayName: "Modal__StyledShadow",
  componentId: "sc-isf1yd-1"
})(["top:0;left:0;right:0;bottom:0;z-index:-1;position:fixed;touch-action:none;background-color:rgba(0,0,0,0.75);-webkit-tap-highlight-color:transparent;"]);
var _default = exports["default"] = Modal;